<template>
  <div class="form-column">
    <label class="label flex flex-align-center flex-justify-between text-smaller">
      <span class="text-uppercase">
        Line {{ index + 1 }}
      </span>
    </label>
    <div style="padding: .3125em .5em .25em;">
      <i>Blank</i>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    index: {
      type: Number,
      default: 0,
    },
    line: {
      required: true,
      type: Object,
    },
  },
}
</script>